import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import queryString from "query-string";
import Layout from "@common/layout/Layout";
import PackageTable from "./PackageTable";
import packagesCubeQuery from "../graphql/packagesCubeQuery.graphql";
import packagesFilterQuery from "../graphql/packagesFilterQuery.graphql";
import useGetQueryVariables from "@dimensions/hooks/useGetQueryVariables";
import { PackagePage } from "@models/ISchema";

const PackageSearch: React.FC = () => {
  // Using React Router's useLocation hook to get the query parameters from the URL
  const location = useLocation();
  const params: queryString.ParsedQuery<string> = queryString.parse(location.search);

  // State for managing current page
  const [page, setPageCount] = useState(1);

  // Get the query variables using the custom hook, based on the URL parameters and pagination settings
  const variables = useGetQueryVariables(params, page, !params?.advance);

  // Choose the appropriate query based on the 'advance' parameter from the URL
  const packageSearchQuery = params?.advance ? packagesFilterQuery : packagesCubeQuery;

  // Fetch data using the Apollo useQuery hook with the chosen query and variables
  const { loading, error, data } = useQuery(packageSearchQuery, {
    variables,
    fetchPolicy: "network-only",
  });
  let packages: PackagePage = data?.cube?.packages;

  // Assign the fetched data depending on the query used
  if (params?.advance) packages = data?.filter?.packages;

  // Render the Layout component and pass the packages data to the <PackageTable> component for display
  return (
    <Layout contextSearch>
      <PackageTable
        data={packages?.items} // Items from packages data
        search={params?.search?.toString()} // Search query from URL
        pageInfo={packages?.pageInfo} // Page information for pagination
        setPage={(value: number) => setPageCount(value)} // Function to update the page number
        loading={loading} // Pass loading state from useQuery
        error={error} // Pass error state from useQuery
      />
    </Layout>
  );
};

export default PackageSearch;
